export const typingIndicatorStyles = {
  root: "flex w-full items-center gap-2 rounded-2xl bg-muted px-3.5 py-2.5",
  sparkle: "shrink-0 animate-spin",
  label: "text-xs text-muted-foreground",
};
